const s = (slug, title, aliases = []) => ({ slug, title, aliases });

export const SCREEN_GROUPS = [
  {
    group: "Dashboard",
    screens: [s("dashboard", "Dashboard", ["/flows/dashboard"])],
  },
  {
    group: "Add Funds",
    screens: [
      s("add-funds-banking-portal", "Add Funds - Banking Portal", [
        "/add-funds/banking-portal",
      ]),
      s("add-funds-direct-debit", "Add Funds - Direct Debit", [
        "/add-funds/direct-debit",
      ]),
    ],
  },
  {
    group: "Recipients",
    screens: [
      s("add-recipient", "Add Recipient", ["/recipients/add"]),
      s("recipient", "Recipient", ["/recipients"]),
    ],
  },
  {
    group: "Cards",
    screens: [
      s("cards-company-cards", "Cards - Company Cards", ["/cards/company"]),
      s("cards-employee-cards", "Cards - Employee Cards", ["/cards/employee"]),
      s("cards-settings", "Cards - Settings", ["/cards/settings"]),
      s("cards-summary-details-cards-1", "Cards - Summary Details Cards-1", [
        "/cards/summary/alternate",
      ]),
      s("cards-summary-details-cards", "Cards - Summary Details Cards", [
        "/cards/summary",
      ]),
      s("create-company-card-1", "Create Company Card-1", [
        "/cards/create-company/employee",
      ]),
      s("create-company-card", "Create Company Card", ["/cards/create-company"]),
      s("create-new-card", "Create New Card", ["/cards/create"]),
    ],
  },
  {
    group: "Convert",
    screens: [
      s("convert-new-conversion", "Convert - New Conversion", [
        "/convert/new-conversion",
      ]),
    ],
  },
  {
    group: "Credit",
    screens: [
      s("credit-details", "Credit Details", ["/credit/details"]),
      s("credit-report-overview", "Credit Report Overview", [
        "/credit/report-overview",
      ]),
      s("factors-impacting-score", "Factors Impacting Score", [
        "/credit/factors-impacting-score",
      ]),
    ],
  },
  {
    group: "Invite People",
    screens: [
      s("invite-people-my-invites-pop-up", "Invite People - My Invites Pop Up", [
        "/invite-people/my-invites/popup",
      ]),
      s("invite-people-my-invites", "Invite People - My Invites", [
        "/invite-people/my-invites",
      ]),
      s("invite-people-referral-centre", "Invite People - Referral Centre", [
        "/invite-people/referral-centre",
      ]),
    ],
  },
  {
    group: "Invoice Generator",
    screens: [
      s("invoice-generator-1", "Invoice Generator-1", ["/invoice-flow/review"]),
      s("invoice-generator-2", "Invoice Generator-2", ["/invoice-flow/created"]),
      s("invoice-generator", "Invoice Generator", ["/invoice-flow/create"]),
    ],
  },
  {
    group: "Manage My Spending",
    screens: [
      s("manage-my-spending-budget-setup-1", "Manage My Spending - Budget Setup-1", [
        "/manage-spending/budget-setup/alternate",
      ]),
      s("manage-my-spending-budget-setup", "Manage My Spending - Budget Setup", [
        "/manage-spending/budget-setup",
      ]),
      s("manage-my-spending-budget-tracking", "Manage My Spending - Budget Tracking", [
        "/manage-spending/budget-tracking",
      ]),
      s("manage-my-spending-create-budget", "Manage My Spending - Create Budget", [
        "/manage-spending/create-budget",
      ]),
      s("manage-my-spending-manage-tag-popup", "Manage My Spending - Manage Tag Popup", [
        "/manage-spending/tags/popup",
      ]),
      s("manage-my-spending-my-bills-add-billers", "Manage My Spending - My Bills - Add Billers", [
        "/manage-spending/my-bills/add-billers",
      ]),
      s("manage-my-spending-my-bills-billers-list-view", "Manage My Spending - My Bills - Billers [List View]", [
        "/manage-spending/my-bills/billers",
      ]),
      s("manage-my-spending-my-bills-billers-all-bills-calendar-view", "Manage My Spending - My Bills - Billers All Bills [Calendar View]", [
        "/manage-spending/my-bills/calendar/all",
      ]),
      s("manage-my-spending-my-bills-billers-annually-calendar-view", "Manage My Spending - My Bills - Billers Annually [Calendar View]", [
        "/manage-spending/my-bills/calendar/annually",
      ]),
      s("manage-my-spending-my-bills-billers-daily-calendar-view", "Manage My Spending - My Bills - Billers Daily [Calendar View]", [
        "/manage-spending/my-bills/calendar/daily",
      ]),
      s("manage-my-spending-my-bills-billers-fortnightly-calendar-view", "Manage My Spending - My Bills - Billers Fortnightly [Calendar View]", [
        "/manage-spending/my-bills/calendar/fortnightly",
      ]),
      s("manage-my-spending-my-bills-billers-monthly-calendar-view", "Manage My Spending - My Bills - Billers Monthly [Calendar View]", [
        "/manage-spending/my-bills/calendar/monthly",
      ]),
      s("manage-my-spending-my-bills-billers-quarterly-calendar-view", "Manage My Spending - My Bills - Billers Quarterly [Calendar View]", [
        "/manage-spending/my-bills/calendar/quarterly",
      ]),
      s("manage-my-spending-my-bills-billers-weekly-1-calendar-view", "Manage My Spending - My Bills - Billers Weekly 1 [Calendar View]", [
        "/manage-spending/my-bills/calendar/weekly-primary",
      ]),
      s("manage-my-spending-my-bills-billers-weekly-2-calendar-view", "Manage My Spending - My Bills - Billers Weekly 2 [Calendar View]", [
        "/manage-spending/my-bills/calendar/weekly-secondary",
      ]),
      s("manage-my-spending-setup-pop-up", "Manage My Spending - Setup Pop Up", [
        "/manage-spending/setup/popup",
      ]),
      s("manage-my-spending-spending-report-1", "Manage My Spending - Spending Report-1", [
        "/manage-spending/spending-report/alternate",
      ]),
      s("manage-my-spending-spending-report", "Manage My Spending - Spending Report", [
        "/manage-spending/spending-report",
      ]),
      s("manage-my-spending", "Manage My Spending", ["/manage-spending"]),
    ],
  },
  {
    group: "My Accounts",
    screens: [
      s("my-accounts-connect-new-account", "My Accounts - Connect New Account", [
        "/my-accounts/connect-new-account",
      ]),
      s("my-accounts", "My Accounts", ["/my-accounts"]),
    ],
  },
  {
    group: "My Bills",
    screens: [
      s("my-bills-create-transaction-advanced-view", "My Bills - Create Transaction - Advanced View", [
        "/my-bills/create-transaction/advanced",
      ]),
      s("my-bills-create-transaction-simplified-view", "My Bills - Create Transaction - Simplified View", [
        "/my-bills/create-transaction",
      ]),
      s("my-bills", "My Bills", ["/my-bills/overview"]),
    ],
  },
  {
    group: "My Transactions",
    screens: [
      s("my-transactions-details", "My Transactions - Details", [
        "/my-transactions/details",
      ]),
      s("my-transactions", "My Transactions", ["/my-transactions"]),
    ],
  },
  {
    group: "Overview",
    screens: [
      s("overview-net-worth", "Overview - Net Worth", ["/overview/net-worth"]),
      s("overview", "Overview", ["/overview/finance"]),
    ],
  },
  {
    group: "Plan For Retirement",
    screens: [
      s("plan-for-retirement", "Plan For Retirement", [
        "/plan-for-retirement/overview",
      ]),
    ],
  },
  {
    group: "QR Payment",
    screens: [
      s("qr-payment-qr-pay", "QR Payment - QR Pay", ["/qr-payment/pay"]),
      s("qr-payment-qr-receive", "QR Payment - QR Receive", ["/qr-payment/receive"]),
    ],
  },
  {
    group: "Request Money",
    screens: [
      s("request-money-1", "Request Money-1", ["/request-money/details"]),
      s("request-money-2", "Request Money-2", ["/request-money/review"]),
      s("request-money-3", "Request Money-3", ["/request-money/confirmation"]),
      s("request-money", "Request Money", ["/request-money/create"]),
    ],
  },
  {
    group: "Save And Invest",
    screens: [
      s("save-and-invest", "Save and Invest", ["/save-and-invest/overview"]),
    ],
  },
  {
    group: "Schedule Your Transfer",
    screens: [
      s("schedule-your-transfer-review-1", "Schedule Your Transfer - Review-1", [
        "/schedule-transfer/review/alternate",
      ]),
      s("schedule-your-transfer-review", "Schedule Your Transfer - Review", [
        "/schedule-transfer/review",
      ]),
      s("schedule-your-transfer-1", "Schedule Your Transfer-1", [
        "/schedule-transfer/details",
      ]),
      s("schedule-your-transfer", "Schedule Your Transfer", [
        "/schedule-transfer/create",
      ]),
    ],
  },
  {
    group: "Send Money",
    screens: [
      s("send-money-existing-recipients-review", "Send Money - Existing Recipients Review", [
        "/new-transfer/existing-recipients/review",
      ]),
      s("send-money-existing-recipients", "Send Money - Existing Recipients", [
        "/new-transfer/existing-recipients",
      ]),
      s("send-money-someone-new-bpay-review", "Send Money - Someone New BPAY Review", [
        "/new-transfer/someone-new/bpay/review",
      ]),
      s("send-money-someone-new-bpay", "Send Money - Someone New BPAY", [
        "/new-transfer/someone-new/bpay",
      ]),
      s("send-money-someone-new-domestic-transfer-review", "Send Money - Someone New Domestic Transfer Review", [
        "/new-transfer/someone-new/domestic/review",
      ]),
      s("send-money-someone-new-domestic-transfer", "Send Money - Someone New Domestic Transfer", [
        "/new-transfer/someone-new/domestic",
      ]),
      s("send-money-someone-new-international-transfer-recipients-informations", "Send Money - Someone New International Transfer Recipients Informations", [
        "/new-transfer/someone-new/international/recipient-info",
      ]),
      s("send-money-someone-new-international-transfer-review", "Send Money - Someone New International Transfer Review", [
        "/new-transfer/someone-new/international/review",
      ]),
      s("send-money-someone-new-international-transfer", "Send Money - Someone New International Transfer", [
        "/new-transfer/someone-new/international",
      ]),
    ],
  },
  {
    group: "Split Payment",
    screens: [
      s("split-payment-add-expenses-equally", "Split Payment - Add Expenses (Equally)", [
        "/split-payment/add-expenses/equally",
      ]),
      s("split-payment-add-expenses-unequally", "Split Payment - Add Expenses (Unequally)", [
        "/split-payment/add-expenses/unequally",
      ]),
      s("split-payment-all-expenses", "Split Payment - All Expenses", [
        "/split-payment/expenses",
      ]),
      s("split-payment-all-groups", "Split Payment - All Groups", [
        "/split-payment/groups",
      ]),
      s("split-payment-create-group", "Split Payment - Create Group", [
        "/split-payment/create-group",
      ]),
      s("split-payment-group-balance-detail", "Split Payment - Group Balance Detail", [
        "/split-payment/group-balance-detail",
      ]),
      s("split-payment-group-details", "Split Payment - Group Details", [
        "/split-payment/group-details",
      ]),
      s("split-payment-reminder", "Split Payment - Reminder", [
        "/split-payment/reminder",
      ]),
      s("split-payment-settle-up", "Split Payment - Settle Up", [
        "/split-payment/settle-up",
      ]),
      s("split-payment-split-summary", "Split Payment - Split Summary", [
        "/split-payment/summary",
      ]),
      s("split-payment-view-by-person", "Split Payment - View by Person", [
        "/split-payment/view-by-person",
      ]),
    ],
  },
  {
    group: "Statement",
    screens: [s("statement", "Statement", ["/statements"])],
  },
  {
    group: "Wallet",
    screens: [
      s("wallet-account-activity-view-by-account", "Wallet - Account Activity (View by Account)", [
        "/wallet/account-activity",
      ]),
      s("wallet-balance-view-by-currency", "Wallet - Balance (View by Currency)", [
        "/wallet/balance",
      ]),
      s("wallet-balance-details-view-by-currency", "Wallet - Balance Details (View by Currency)", [
        "/wallet/balance-details",
      ]),
      s("wallet-summary-view-by-account", "Wallet - Summary (View by Account)", [
        "/wallet/summary",
      ]),
      s("wallet-transaction", "Wallet - Transaction", ["/wallet/transaction"]),
    ],
  },
];

export const FLOW_SCREENS = SCREEN_GROUPS.flatMap((group) =>
  group.screens.map((screen) => ({ ...screen, group: group.group }))
);

export const SCREEN_BY_SLUG = FLOW_SCREENS.reduce((acc, screen) => {
  acc[screen.slug] = screen;
  return acc;
}, {});

export const FIGMA_FLOW_ROUTES = FLOW_SCREENS.map((screen) => ({
  path: `/flows/${screen.slug}`,
  slug: screen.slug,
}));

export const shortTitle = (title) => title.replace(/\s+-\s+/g, " / ");

export const familyFor = (slug) => {
  if (slug.startsWith("wallet")) return "wallet";
  if (slug.startsWith("send-money")) return "sendMoney";
  if (slug.startsWith("add-funds")) return "addFunds";
  if (slug.includes("recipient")) return "recipients";
  if (slug.startsWith("cards") || slug.startsWith("create-company-card") || slug.startsWith("create-new-card")) return "cards";
  if (slug.startsWith("manage-my-spending")) return "spending";
  if (slug.startsWith("my-bills")) return "bills";
  if (slug.startsWith("split-payment")) return "split";
  if (slug.startsWith("request-money")) return "request";
  if (slug.startsWith("invoice-generator")) return "invoice";
  if (slug.startsWith("schedule-your-transfer")) return "schedule";
  if (slug.startsWith("credit") || slug.startsWith("factors-impacting-score")) return "credit";
  if (slug.startsWith("qr-payment")) return "qr";
  if (slug.startsWith("invite-people")) return "invite";
  if (slug.startsWith("my-accounts")) return "accounts";
  if (slug.startsWith("my-transactions")) return "transactions";
  if (slug.startsWith("overview")) return "overview";
  if (slug.startsWith("convert")) return "convert";
  if (slug.startsWith("plan-for-retirement")) return "retirement";
  if (slug.startsWith("save-and-invest")) return "invest";
  if (slug.startsWith("statement")) return "statement";
  return "dashboard";
};

export const siblingScreens = (screen) =>
  FLOW_SCREENS.filter((item) => item.group === screen.group);
